export const DA_SCROLLER_TYPE = 'da-scroller-plugin';

//# sourceMappingURL=types.js.map